var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClockRainbowLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  rx: 22,
  fill: "white"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_326_24646)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 11,
  width: 22,
  height: 22,
  rx: 11,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 11,
  width: 22,
  height: 22,
  fill: "#F83F23"
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 11,
  width: 5.5,
  height: 3.88667,
  fill: "#FFBA11"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.3673 11C26.3961 12.8891 26.9106 14.1462 26.9106 15.3972C26.9106 16.5557 26.6056 17.6939 26.0263 18.6972C25.1421 20.2287 23.3614 21.2568 19.8001 23.313L12.6912 11H25.3673Z",
  fill: "#FFBA11"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 24.5667V13.5667C15.1123 13.5667 17.1685 13.5667 18.7 14.4509C19.7033 15.0302 20.5365 15.8633 21.1158 16.8667C22 18.3982 22 20.4543 22 24.5667H11Z",
  fill: "#FFDC00"
}), /*#__PURE__*/React.createElement("rect", {
  x: 29.26,
  y: 29.4067,
  width: 3.74,
  height: 3.59333,
  fill: "#6AF0DB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6129 33.0001H11V24.2559C12.0113 22.6395 12.8023 21.6666 13.8123 21.0835C14.8156 20.5042 15.9537 20.1992 17.1123 20.1992C18.8808 20.1992 20.6614 21.2273 24.2228 23.2835L18.6129 33.0001Z",
  fill: "#14CC80"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.3146 33.0001H18.6395C17.6214 31.1274 17.1123 29.8769 17.1123 28.6325C17.1123 27.474 17.4173 26.3359 17.9965 25.3325C18.6758 24.1559 19.8842 23.2765 22.0226 21.9998C23.6843 22.9257 24.8725 23.4946 25.949 23.7066L31.3146 33.0001Z",
  fill: "#6AF0DB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.2482 21.7678C23.3187 26.7216 27.7259 30.4333 33 30.4333L33 19.4333H32.5655C29.7723 21.9037 25.8664 22.8069 22.2482 21.7678Z",
  fill: "#4B19D5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_326_24646"
}, /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 11,
  width: 22,
  height: 22,
  rx: 11,
  fill: "white"
})))));
export default SvgClockRainbowLarge;